document.addEventListener("DOMContentLoaded", () => {
  // Show/hide highlight-products containers based on selected accordion
  function showHighlightCollection(collectionHandle) {
    var productGroups = document.querySelectorAll(".highlight-products");
    productGroups.forEach(function (group) {
      if (
        group.getAttribute("data-highlight-collection") === collectionHandle
      ) {
        group.style.display = "flex";
      } else {
        group.style.display = "none";
      }
    });
  }

  var detailsElements = document.querySelectorAll(
    ".highlights__wrapper .accordion-row"
  );

  function toggleDetails(details) {
    // Remove 'open' and 'active' from all rows before toggling
    detailsElements.forEach(function (element) {
      element.classList.remove("open");
      element.classList.remove("active");
    });
    // If the clicked row was not open, open it
    if (!details.classList.contains("open")) {
      details.classList.add("open");
      details.classList.add("active");
    }
    var collectionHandle = details.getAttribute("data-highlight-collection");
    showHighlightCollection(collectionHandle);

    // After switching, trigger scroll event on the visible scroll-wrapper to update arrow state
    setTimeout(function () {
      var visibleGroup = document.querySelector(
        '.highlight-products[data-highlight-collection="' +
          collectionHandle +
          '"]'
      );
      if (visibleGroup) {
        var scrollWrapper = visibleGroup.querySelector(".scroll-wrapper");
        if (scrollWrapper) {
          scrollWrapper.dispatchEvent(new Event("scroll"));
        }
      }
    }, 0);
  }

  detailsElements.forEach(function (details) {
    var summary = details.querySelector(".highlight-title");
    summary.addEventListener("click", function (e) {
      e.preventDefault();
      toggleDetails(details);
    });
  });

  // Show the first collection on load
  var openDetails = document.querySelector(
    ".highlights__wrapper .accordion-row.open"
  );
  if (openDetails) {
    var collectionHandle = openDetails.getAttribute(
      "data-highlight-collection"
    );
    showHighlightCollection(collectionHandle);
  }
});
